import React, { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import InfiniteScrollReviews from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/InfiniteScrollReviews';
import { Messages3 } from 'iconsax-react';
import { toPersianDigits } from '@/utils/persianUtils';
import { REVIEW_SHEET_CLASS } from '@/components/(postTypes)/platforms/(archive)/layout/(review)/sheetClass';
import { BrokerNode } from '@/stores/selectBrokers/store';
interface AllReviewsProps {
    currentPostId: number[] | number;
    brokers?: BrokerNode[];
    commentCount: number;
}

interface TriggerHtmlProps {
    commentCount: number;
}

const AllReviews: FC<AllReviewsProps> = ({ currentPostId, brokers, commentCount }) => {
    const postIds = Array.isArray(currentPostId) ? currentPostId : [currentPostId];
    // Rendered on the server too (it waited for the browser, so the button popped in late).
    return (
        <Dialog>
            <DialogTrigger className={'flex w-full text-progress'}>
                <TriggerHtml commentCount={commentCount} />
            </DialogTrigger>
            <DialogContent className={REVIEW_SHEET_CLASS}>
                <DialogTitle className='border-b border-black/10 pb-2 text-xl !text-right dark:border-white/10'>
                    نظرات
                </DialogTitle>
                {/* InfiniteScrollReviews places its spinner absolutely */}
                <div className='relative min-h-[100px] flex-1 overflow-y-auto'>
                    <InfiniteScrollReviews postId={postIds} brokers={brokers || []} />
                </div>
            </DialogContent>
        </Dialog>
    );
};

const TriggerHtml: FC<TriggerHtmlProps> = ({ commentCount }) => {
    return (
        <div className='flex w-full items-center justify-center gap-1 rounded-xl border border-progress p-2 text-sm transition-all bg-progress text-white stroke-white hover:bg-blue-400 hover:stroke-white'>
            <Messages3 size='24' className={''} />
            <div>مشاهده</div>
            {commentCount > 0 && <span>{toPersianDigits(String(commentCount))}</span>}
            نظر‌
        </div>
    );
};

export default AllReviews;
